import { Component, Input, OnInit } from '@angular/core'
import { format, isValid, parse } from 'date-fns'

@Component({
  selector: 'ngx-event-times',
  templateUrl: './event-times.component.html',
  styleUrls: ['./event-times.component.scss'],
  standalone: true
})
export class EventTimesComponent implements OnInit {
  @Input() startDate: string
  @Input() endDate: string
  times = ''

  constructor() {}

  ngOnInit(): void {
    this.formatTimes()
  }

  /**
   * Parses and formats the start and end dates into a display string
   */
  private formatTimes(): void {
    if (!this.startDate || !this.endDate) {
      this.times = ''
      return
    }

    try {
      const startDate = parse(this.startDate, 'yyyy-MM-dd HH:mm:ss', new Date())
      const endDate = parse(this.endDate, 'yyyy-MM-dd HH:mm:ss', new Date())

      if (!isValid(startDate) || !isValid(endDate)) {
        this.times = ''
        return
      }

      const formattedStart = format(startDate, 'dd MMM').toUpperCase()
      const formattedEnd = format(endDate, 'dd MMM').toUpperCase()

      this.times = `${formattedStart} / ${formattedEnd}`
    } catch {
      this.times = ''
    }
  }
}
